import {
  CREATE_RETAILER_REQUEST,
  CREATE_RETAILER_RESPONSE,
  CREATE_RETAILER_ERROR,
} from '../../actions/Admin/adminRetailerSettingsAction';
import { IBaseRequest } from '../../types';

const initialState: IBaseRequest = {
  loading: false,
  error: '',
};

const createRetailerReducer = (
  state: IBaseRequest = initialState,
  action: any,
): IBaseRequest => {
  switch (action.type) {
    case CREATE_RETAILER_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case CREATE_RETAILER_RESPONSE:
      return {
        ...state,
        loading: false,
        error: '',
      };
    case CREATE_RETAILER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error || 'Error creating retailer',
      };
    default:
      return state;
  }
};

export default createRetailerReducer;
